export const TOGGLE_MODAL = 'TOGGLE_MODAL'
